// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home[data-v-6b58139a]{margin-top:50px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
